// This module throws an error for exceptions that
// happen within a Promise, so that they may be logged.

// If an unhandled rejection happens, 
// that means a promise was missing a catch and needs to be fixed
window.addEventListener('unhandledrejection', err => setTimeout(() => { throw err }, 0))

export default (err) => setTimeout(()=> { throw err }, 0)